import { useQuery } from "@tanstack/react-query";
import { getCompleteStops } from "../../../services/cdkOrderService";

const useGetCompleteStops = () => {
  const query = useQuery({
    queryKey: ["completeStops"],
    queryFn: getCompleteStops,
  });

  return query;
};

export default useGetCompleteStops;
